var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_box_view"},[_c('img',{attrs:{"src":_vm.emptyBox,"alt":""}}),_c('h4',[_vm._v("Data Not Found")])])}
var staticRenderFns = []

export { render, staticRenderFns }